const alerts = document.querySelectorAll('.module-alert')

if(alerts) {
  alerts.forEach(alert => {
    let alertCloseBtn = alert.querySelector('.close-alert')
    if(alertCloseBtn) {
      alertCloseBtn.onclick = (e) => {
        e.preventDefault()
        alert.remove()
      }
    }
  })
}



// WEBPACK FOOTER //
// ./scripts/modules/alert.js